<template>
  <div class="billing-view">
    <div class="billing-view__item">
      <label class="billing-view__item__label">{{ $t('companyName') }}</label>
      <div>{{ get('{company}') }}</div>
    </div>
    <div class="billing-view__item">
      <label class="billing-view__item__label">{{ $t('orgNo') }}</label>
      <div>{{ get('{organizationNumber}') }}</div>
    </div>
    <div class="billing-view__item">
      <label class="billing-view__item__label">{{ $t('email') }}</label>
      <div>{{ get('{email}') }}</div>
    </div>
  </div>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'

export default {
  props: {
    value: Object,
  },
  methods: {
    get(str) {
      let target = this.value || this.defaultValues
      return str.replace(/{([^{}]*)}/g, (a, b) => this.$path(b, target))
    },
  },
  computed: {
    defaultValues() {
      return this.$store.state.enums.ClientDetails
    },
  },
  components: {
    ButtonComponent,
  },
}
</script>

<style lang="scss" scoped>
.billing-view {
  display: flex;
  gap: 2rem;
  padding: 1rem;

  &__item {
    display: flex;
    flex-direction: column;

    &__label {
      font-size: 0.8em;
      opacity: 0.6;
    }
  }
}
</style>
